<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;margin-top: 30px;" :getContainer="handleScollMain">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-form-item label="管理员" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-form-item :style="{ display: 'inline-block', width: '60%', marginBottom: '0' }">
              <a-input :disabled="true" placeholder="请选择管理员" v-decorator="[
                'telephone',
                { rules: [{ required: true, message: '请选择管理员!' }], initialValue: info.telephone }
              ]"></a-input>
            </a-form-item>
            <a-form-item :style="{ display: 'inline-block', marginLeft: '15px', marginBottom: '0' }">
              <pxkeji-btn name="选择管理员" type="primary" @click="selectUser" />
            </a-form-item>
          </a-form-item>
          <a-form-item label="子站名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入子站名称" v-decorator="[
              'siteName',
              { rules: [{ required: true, message: '请输入子站名称!' }], initialValue: info.siteName }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="子站简称" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入子站简称" v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入子站简称!' }], initialValue: info.name }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="管理员手机" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入管理员手机号" v-decorator="[
              'adminTel',
              { rules: [{ required: true, message: '请输入子站简称!' }], initialValue: info.adminTel }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="域名" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入域名" v-decorator="[
              'domain',
              { rules: [{ required: true, message: '请输入域名!' }], initialValue: info.domain }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="排序" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="请输入排序号" v-decorator="[
              'orderno',
              {
                rules: [{ required: true, message: '请输入排序号!' }], initialValue: info.orderno
              }
            ]"></a-input>
          </a-form-item>
          <a-form-item label="所属省份" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-select placeholder="请选择省份" v-decorator="[
              'province',
              { rules: [{ required: true, message: '请选择省份!' }], initialValue: info.province }
            ]">
              <a-select-option :value="info.name" v-for="(info, index) in areaList"
                :key="index">{{ info.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="logo图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-upload :action="$api.file.uploadFile" listType="picture-card" :beforeUpload="beforeUpload"
              :fileList="fileList" @preview="handlePreview" @change="handleChange">
              <div v-if="fileList.length == 0">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-form-item label="LOGO跳转地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-input placeholder="LOGO跳转地址" v-decorator="[
              'logo_redirect_url',
              {
                rules: [{ pattern: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/, message: '请输入正确的URL!' }], initialValue: info.logo_redirect_url
              }
            ]"></a-input>

          </a-form-item>

          <a-form-item label="favicon图标" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-upload :action="$api.file.uploadFile" listType="picture-card" :multiple="false"
              :beforeUpload="beforeUpload" :fileList="favicon.fileList" @preview="handlePreviewFavicon"
              @change="handleChangeFavicon">
              <div v-if="favicon.fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="favicon.visible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="favicon.preview" />
            </a-modal>
          </a-form-item>

          <a-form-item label="首页通栏" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <ImgaeUpload @getFileList="getFileList" :images="topImage"></ImgaeUpload>
          </a-form-item>

          <a-form-item label="状态" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-switch v-model="info.status" v-decorator="[
              'status',
              { rules: [] }
            ]" />
          </a-form-item>
          <a-form-item label="是否显示在首页" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-switch v-model="info.isShow" v-decorator="[
              'isShow',
              { rules: [] }
            ]" />
          </a-form-item>
          <a-form-item label="是否是行业站点" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
            <a-switch v-model="info.isHangye" v-decorator="[
              'isHangye',
              { rules: [] }
            ]" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
      <a-modal title="选择用户" v-model="visible" width="75%" :footer="false" destroyOnClose :maskClosable="false">
        <UserList :id="info.userId" @callbackMethod="getUserInfo" />
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import UserList from "./userlist.vue"; //用户列表
import ImgaeUpload from "./components/upload.vue"; //上传图片
var that;
export default {
  name: "areaInfo",
  props: {
    id: String,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        status: true,
        isShow: true,
        isHangye: true,
      },
      favicon: {
        preview: "",
        path: "",
        fileList: [],
        visible: false,
      },
      previewVisible: false,
      previewImage: "",
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      uploadImg: [],
      visible: false,
      areaList: [],
      topImage:[],
    };
  },
  components: {
    UserList: UserList,
    ImgaeUpload:ImgaeUpload,
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      this.areaList = this.$api.city.city;
      if (this.id && this.id != "0") {
        this.getInfo();
      }
    });
  },
  methods: {
    //获取首页通栏信息
    getFileList(e){
      this.topImage = e;
    },
    selectUser() {
      this.visible = true;
    },
    getUserInfo(userInfo) {
      this.visible = false;
      this.info.userId = userInfo.id;
      this.info.telephone = userInfo.realName + " (" + userInfo.telephone + ")";
      this.form.setFieldsValue({ telephone: this.info.telephone });
    },
    getInfo() {
      this.$api.area
        .getAreaInfoById(this.id)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            this.info.status = this.$commen.changeIntBoolean(res.data.status);
            this.info.isShow = this.$commen.changeIntBoolean(res.data.isShow);
            this.info.isHangye = this.$commen.changeIntBoolean(res.data.isHangye);
            if (res.data.logoUrl) {
              var picurlArr = res.data.logoUrl.split(",");
              picurlArr.forEach(function (item, index) {
                that.fileList.push({
                  name: "img" + index,
                  response: { data: { name: "img" + index, path: item } },
                  status: "done",
                  uid: index,
                  thumbUrl: item,
                });
              });
            }
            if (res.data.favicon) {
              var faviconPic = res.data.favicon;
              that.favicon.fileList.push({
                name: "imgFavicon",
                response: { data: { name: "imgFavicon", path: faviconPic } },
                status: "done",
                uid: "imgFavicon",
                thumbUrl: faviconPic,
              });
            }
            if (res.data.top_image) {
              var topImagePic = res.data.top_image;
              that.topImage.push({
                name: "topImage",
                response: { data: { name: "topImage", path: topImagePic } },
                status: "done",
                uid: "topImage",
                thumbUrl: topImagePic,
              });
            }
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          values.userId = this.info.userId;
          this.isloading = true;
          if (this.id > 0) {
            values.id = this.id;
          }
          if (this.fileList) {
            this.uploadImg = [];
            this.fileList.forEach(function (item, index) {
              that.uploadImg.push(item.response.data.path);
            });
            values.logoUrl = this.uploadImg.join(",");
          }
          values.status = this.$commen.changeBooleanInt(this.info.status);
          values.isShow = this.$commen.changeBooleanInt(this.info.isShow);
          values.isHangye = this.$commen.changeBooleanInt(this.info.isHangye);
          this.favicon.fileList.forEach(function (item, index) {
            values.favicon = that.favicon.path = item.response.data.path;
          });
          this.topImage.forEach(function (item, index) {
            values.top_image = item.response.data.path;
          });
          this.$api.area
            .saveOrUpdate(values)
            .then((res) => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.$emit("callbackMethod", res.data);
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },

    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handleCancel() {
      this.previewVisible = false;
      this.favicon.visible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handlePreviewFavicon(file) {
      //预览
      this.favicon.preview = file.url || file.thumbUrl;
      this.favicon.visible = true;
    },
    handleChangeFavicon(info) {
      var that = this;
      //完成上传回掉
      if (info.file.status=="done" || info.file.status=="uploading") {
        this.favicon.fileList = info.fileList;
      } else {
        this.favicon.fileList = [];
      }
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    handleScollMain() {
      return document.querySelector(".ant-modal-wrap");
    },
  },
};
</script>
<style></style>